import { appLink } from '@app/config/appLink'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import UseCasePageHeader from '../components/UseCaseHeader'
import { USE_CASES_MAP } from '../config/useCases.config'
import { UseCaseId } from '../types'
import UseCaseTabNav from '../components/UseCaseTabNav'

const UseCasesPageTemplate = () => {
  const { useCaseId } = useParams<{ useCaseId: UseCaseId }>()
  const useCase = useCaseId ? USE_CASES_MAP[useCaseId] : null

  const navigate = useNavigate()

  if (!useCase)
    return (
      <div className="flex flex-col items-center justify-center gap-4 py-24 text-center">
        <p className="text-muted-foreground">
          Use case not found: <span className="font-mono">{useCaseId}</span>
        </p>
        <button
          onClick={() => navigate(appLink.homeWelcome.path)}
          className="text-sm font-medium text-primary underline-offset-4 hover:underline"
        >
          Back to welcome
        </button>
      </div>
    )
  return (
    <div>
      <UseCasePageHeader useCase={useCase} />
      <UseCaseTabNav />
      <Outlet />
    </div>
  )
}

export default UseCasesPageTemplate
